import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserdataModel } from '../providers/userdata-model';

/* Game data are in the variable gamesData in this provider */

@Injectable()
export class GameModel {
    gamesData: any=[];

    constructor(private storage: Storage, public userdataModel:UserdataModel){
		this.getGamesDataStored();
    }

    addWord(
        idBook:number,
        idGame: number,
        round:number,
        attempt:number,
        bookmark:number,
        bookmarkLetter:number,
        time:number,
        skipLeft:number,
        tsInsert:number,
        skipUsed:boolean,
        lettersRemovedWhenThanosHit:string,
        word:string,
        wordToGuess: string,
        wordIndex: string,
        isCorrect:boolean,
        scoreEarned:number,
        attemptsWrong:number){
        this.gamesData[this.getArrayPositionLastGame()].wordstyped.push({
            idBook: idBook,
            round: round,
            attempt: attempt,
            bookmark: bookmark,
            bookmarkLetter: bookmarkLetter,
            time: time,
            skipLeft: skipLeft,
            tsInsert: tsInsert,
            skipUsed: skipUsed,
            lettersRemovedWhenThanosHit: lettersRemovedWhenThanosHit,
            word: word,
            wordToGuess: wordToGuess,
            wordIndex: wordIndex,
            isCorrect: isCorrect,
            scoreEarned: scoreEarned,
            attemptsWrong: attemptsWrong
        });
        this.storeGamesData();
    }

    addGame(
        guidUser: string,
        idGame: number,
        idBook:number,
        currentDevice:any,
        numSntToGuess: number,
        numLetterGuessableSimul: number,
        numCharacterPriorOrPosterior: number,
        coefficentGoAheadOnCutBook: number,
        numLetterToConsiderInASingleGame: number,
        booksPlayable: string,
        booksPlayableInVersus: string,
        keyboards:string,
        tsBegingame:number,
        tsEndgame:number,
        difficulty:string,
        gamemode: string,
        language:string,
        scoreInitial:number,
        scoreFinal:number,
        parVersion: number,
        skipInitial:number,
        skipFinal:number,
        bookmarkInitial:number,
        bookmarkFinal:number,
        bookmarkLetterInitial:number,
        bookmarkLetterFinal:number,
        idChunkInBookInitial:number,
        idChunkInBookFinal:number,
        levelInitial:number,
        levelFinal:number,
        fartherIndexDashReachedDuringGame:number,
        numCorrette: number,
        numSbagliate: number,
        priorOrPosteriorIndexes:string,
        giveup:boolean,
        win:boolean,
        guidUserVersus: string,
        idGameVersus: string,
        timeFinal:number,
        wordstyped:any){
        this.gamesData.push({
            guidUser:guidUser,
            idGame:idGame,
            idBook: idBook,
            currentDevice: currentDevice,
            numSntToGuess: numSntToGuess,
            numLetterGuessableSimul: numLetterGuessableSimul,
            numCharacterPriorOrPosterior: numCharacterPriorOrPosterior,
            coefficentGoAheadOnCutBook: coefficentGoAheadOnCutBook,
            numLetterToConsiderInASingleGame: numLetterToConsiderInASingleGame,
            booksPlayable: booksPlayable,
            booksPlayableInVersus: booksPlayableInVersus,
            keyboards: keyboards,
            tsBegingame: tsBegingame,
            tsEndgame: tsEndgame,
            difficulty: difficulty,
            gamemode: gamemode,
            language: language,
            scoreInitial: scoreInitial,
            scoreFinal: scoreFinal,
            parVersion: parVersion,
            skipInitial: skipInitial,
            skipFinal: skipFinal,
            bookmarkInitial:bookmarkInitial,
            bookmarkFinal:bookmarkFinal,
            bookmarkLetterInitial:bookmarkLetterInitial,
            bookmarkLetterFinal:bookmarkLetterFinal,
            idChunkInBookInitial:idChunkInBookInitial,
            idChunkInBookFinal:idChunkInBookFinal,
            levelInitial: levelInitial,
            levelFinal: levelFinal,
            fartherIndexDashReachedDuringGame:fartherIndexDashReachedDuringGame,
            numCorrette:numCorrette,
            numSbagliate:numSbagliate,
            priorOrPosteriorIndexes:priorOrPosteriorIndexes,
            giveup:giveup,
            win:win,
            guidUserVersus: guidUserVersus,
            idGameVersus: idGameVersus,
            timeFinal: timeFinal,
            wordstyped: wordstyped || []
        });

        this.storeGamesData();
    }

    getNewGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.getIdLastGame()+1;
        }
        console.log("++++ New game id: "+idGame);
        return idGame;
    }

    getCurrentGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.getIdLastGame();
        }
        return idGame;
    }

    /*removeItem(gameData){
        var i:number;
        for(i = 0; i < this.gameData.length; i++) {
            if(this.gameData[i] == item){
                this.gameData.splice(i, 1);
            }
        }
    }*/

    getNumGamesPlayed(){
        return this.gamesData.length;
    }

    isGameModeVersusLastGamePlayed(){
        if (this.getLastGameData().guidUserVersus!="") {
            return true;
        } else {
            return false;
        }
    }

    getIdLastGame(){
        return this.getLastGameData().idGame;
    }

    getArrayPositionLastGame(){
        return this.gamesData.length-1;
    }

    // This maintain funcionality if gameid are not sequential
    getArrayPositionGameWithId(idGame){
        for (let i = (this.gamesData.length-1); i >= 0; i--) {
            if (this.gamesData[i].idGame==idGame) {
                return i;
            }
        }
        return -1;
    }

    /* --------- GETTER/SETTER --------- */

    setWholeGamesData(gamesdata){
        this.gamesData=gamesdata;
        this.storeGamesData();
    }

    getWholeGamesData(){
        return this.gamesData;
    }

    storeGamesData(){
        return new Promise((resolve) =>{
            this.storage.set('gamesData', JSON.stringify(this.gamesData)).then((val) => {
                resolve("storeGamesDataOk");
            })
        });
    }

    getGamesDataStored(){
        this.storage.get('gamesData').then((gamesData) => {
            if(gamesData){
                this.gamesData=JSON.parse(gamesData);
            }else{
                this.gamesData=[];
            }
        });
    }

    clearGamesData(){
        return new Promise((resolve) =>{
            this.gamesData=[];
            this.gamesData.push({});
            this.storeGamesData().then((response)=>{
                resolve("storeGamesDataOk");
            });
        });
    }

    getLastGameData(){
        return this.gamesData[this.getArrayPositionLastGame()];
    }

    setTsEndgame(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].tsEndgame=value;
        this.storeGamesData();
    }

    getTsEndgame(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].tsEndgame;
    };

    setScoreFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].scoreFinal=value;
        this.storeGamesData();
    }

    getScoreFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].scoreFinal;
    };

    setSkipFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].skipFinal=value;
        this.storeGamesData();
    }

    getSkipFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].skipFinal;
    };

    setBookmarkFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkFinal=value;
        this.storeGamesData();
    }

    getBookmarkFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkFinal;
    };

    setPriorOrPosteriorIndexes(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].priorOrPosteriorIndexes=value;
        this.storeGamesData();
    }

    getPriorOrPosteriorIndexes(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].priorOrPosteriorIndexes;
    };

    setBookmarkLetterFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkLetterFinal=value;
        this.storeGamesData();
    }

    getBookmarkLetterFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkLetterFinal;
    };

    setIdChunkInBookInitial(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookInitial=value;
        this.storeGamesData();
    }

    getIdChunkInBookInitial(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookInitial;
    };

    setIdChunkInBookFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookFinal=value;
        this.storeGamesData();
    }

    getIdChunkInBookFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookFinal;
    };

    setLevelInitial(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].levelInitial=value;
        this.storeGamesData();
    }

    getLevelInitial(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].levelInitial;
    };

    setLevelFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].levelFinal=value;
        this.storeGamesData();
    }

    getLevelFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].levelFinal;
    };

    setFartherIndexDashReachedDuringGame(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].fartherIndexDashReachedDuringGame=value;
        this.storeGamesData();
    }

    getFartherIndexDashReachedDuringGame(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].fartherIndexDashReachedDuringGame;
    };

    setNumCorrette(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].numCorrette=value;
        this.storeGamesData();
    }

    getNumCorrette(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].numCorrette;
    };

    setNumSbagliate(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].numSbagliate=value;
        this.storeGamesData();
    }

    getNumSbagliate(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].numSbagliate;
    }

    setGiveUp(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].giveup=value;    
        this.storeGamesData();    
    }

    getGiveUp(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].giveup;
    };
    
    setWin(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].win=value;    
        this.storeGamesData();    
    }

    getWin(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].win;
    };

    setTimeFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].timeFinal=value;
        this.storeGamesData();
    }

    getTimeFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].timeFinal;
    };

    /* --------- END --------- GETTER/SETTER --------- */
}


// WEBPACK FOOTER //
// ./src/providers/game-model.ts